
<template>
   <div style="display:inline-block;min-width:100px;" contenteditable="true" @input="update"></div>
</template>
<script>
   export default {
    props:['content'],
    data () {
        
        return {}
    },
    mounted:function(){
        this.$el.innerText = this.content;
    },
    methods:{
        update:function(event){
        this.$emit('update',event.target.innerText);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Editable.vue